import { render, staticRenderFns } from "./Fahrzeug.vue?vue&type=template&id=027a4fdd&"
import script from "./Fahrzeug.vue?vue&type=script&lang=js&"
export * from "./Fahrzeug.vue?vue&type=script&lang=js&"
import style0 from "./Fahrzeug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports